const Heading = {
  baseStyle: {
    fontSize: {
      base: '0.86rem',
      lg: '1rem',
    },
    fontWeight: 600,
  },
}

export default Heading
